import { computed, reactive, ref, watch } from "vue";
import { router } from "@inertiajs/vue3";

declare type DrawerName = "menu" | "page:comment";

interface DrawerOptions {
  autoClose?: boolean;
  overlay?: boolean;
  shadow?: boolean;

  [key: string]: any;
}

const defaultOptions: DrawerOptions = {
  autoClose: true,
  overlay: true,
  shadow: true,
};

const currentDrawer = ref<DrawerName | null>(null);
const drawerOptions = ref<DrawerOptions>({});

export default function useCampaignDrawer(name: DrawerName, customOptions: DrawerOptions = {}) {
  router.on("before", () => {
    currentDrawer.value = null;
    drawerOptions.value = {};
  });

  const mergedOptions = computed(() => ({
    ...defaultOptions,
    ...customOptions,
    ...drawerOptions.value,
  }));

  const isOpen = computed(() => currentDrawer.value === name);

  const show = (options: DrawerOptions = {}) => {
    currentDrawer.value = name;
    drawerOptions.value = { ...mergedOptions.value, ...options };
  };

  const hide = () => {
    if (isOpen.value) {
      currentDrawer.value = null;
      drawerOptions.value = {};
    }
  };

  const toggle = (options: DrawerOptions = {}) => {
    if (isOpen.value) {
      hide();
    } else {
      show(options);
    }
  };

  watch(
    () => isOpen.value,
    (isOpen) => {
      if (isOpen) {
        document.body.style.overflow = "hidden";
      } else {
        document.body.style.overflow = "";
      }
    },
  );

  return reactive({
    isOpen,
    options: mergedOptions,
    toggle,
    show,
    hide,
  });
}
